module.exports = __webpack_public_path__ + "img/period.1e6ff93e.png";